export default "__VITE_ASSET__ca503d12__"